<template>
  <el-scrollbar ref="appScrollbar"
                :class="{'app-scrollbar-y': !scrollX}"
                :native="native">
    <slot></slot>
  </el-scrollbar>
</template>

<script>
import {debounce} from 'throttle-debounce'
import { addResizeListener, removeResizeListener } from 'element-ui/lib/utils/resize-event'
export default {
  name: 'AppScrollbar',
  props: {
    native: Boolean,
    scrollX: Boolean
  },
  data () {
    return {
      scrollVisible: true
    }
  },
  methods: {
    // 滑动到顶部
    scrollToTop () {
      let $scrollbar = this.$refs['appScrollbar']
      if ($scrollbar) {
        let wrapView = $scrollbar.$refs['wrap']
        wrapView.scrollTop = 0
      }
    },
    // 滑动到底部
    scrollToBottom () {
      let $scrollbar = this.$refs['appScrollbar']
      if ($scrollbar) {
        let wrapView = $scrollbar.$refs['wrap']
        let resizeView = $scrollbar.$refs['resize']
        let wrapHeight = wrapView.clientHeight
        let resizeHeight = resizeView.scrollHeight
        if (resizeHeight > wrapHeight) {
          wrapView.scrollTop = resizeHeight - wrapHeight
        }
      }
    },
    // 滑动到坐标位置
    scrollToPosition ({left, top}) {
      let $scrollbar = this.$refs['appScrollbar']
      if ($scrollbar) {
        let wrapView = $scrollbar.$refs['wrap']
        let resizeView = $scrollbar.$refs['resize']
        if (typeof left === 'number') {
          let wrapWidth = wrapView.clientWidth
          let resizeWidth = resizeView.scrollWidth
          if (resizeWidth > wrapWidth) {
            if (left < 0) {
              wrapView.scrollLeft = 0
            } else {
              wrapView.scrollLeft = Math.min(left, resizeWidth - wrapWidth)
            }
          }
        }
        if (typeof top === 'number') {
          let wrapHeight = wrapView.clientHeight
          let resizeHeight = resizeView.scrollHeight
          if (resizeHeight > wrapHeight) {
            if (top < 0) {
              wrapView.scrollTop = 0
            } else {
              wrapView.scrollTop = Math.min(top, resizeHeight - wrapHeight)
            }
          }
        }
      }
    },
    // 中心定位
    locationToCenter (current, total) {
      if (total <= 0) {
        return
      }
      let $scrollbar = this.$refs['appScrollbar']
      if ($scrollbar) {
        let wrapView = $scrollbar.$refs['wrap']
        let resizeView = $scrollbar.$refs['resize']
        let wrapHeight = wrapView.clientHeight
        let resizeHeight = resizeView.scrollHeight
        if (resizeHeight > wrapHeight) {
          let scrollOffset = Math.floor(-wrapHeight / 2 + resizeHeight * (current + 1) / total)
          if (scrollOffset < 0) {
            wrapView.scrollTop = 0
          } else if (scrollOffset >= 0 && scrollOffset <= resizeHeight - wrapHeight) {
            wrapView.scrollTop = scrollOffset
          } else {
            wrapView.scrollTop = resizeHeight - wrapHeight
          }
        }
      }
    },
    // 重新定位
    resetLocation () {
      this.$nextTick(() => {
        let $scrollbar = this.$refs['appScrollbar']
        if ($scrollbar) {
          let wrapView = $scrollbar.$refs['wrap']
          if (wrapView.clientWidth || wrapView.clientHeight) {
            let scrollLeft = wrapView.clientWidth * $scrollbar.moveX / 100
            let scrollTop = wrapView.clientHeight * $scrollbar.moveY / 100
            this.scrollToPosition({left: scrollLeft, top: scrollTop})
          }
        }
      })
    },
    // 容器尺寸变化
    updateScroll () {
      this.scrollVisible = this.$el.clientWidth > 0 && this.$el.clientHeight > 0
      this.updateChild()
    },
    // 子元素变化
    updateChild () {
      let $scrollbar = this.$refs['appScrollbar']
      if ($scrollbar) {
        this.$nextTick(() => {
          $scrollbar.update()
        })
      }
    }
  },
  created () {
    this.resizeResolver = debounce(50, this.updateChild)
  },
  mounted () {
    if (this.native) {
      return
    }
    this.$nextTick(() => {
      let $scrollbar = this.$refs['appScrollbar']
      if ($scrollbar) {
        addResizeListener($scrollbar.$refs['wrap'], this.updateScroll)
        let children = $scrollbar.$refs['resize'].children
        if (children) {
          for (let mChild of children) {
            addResizeListener(mChild, this.resizeResolver)
          }
        }
      }
    })
  },
  beforeDestroy () {
    if (this.native) {
      return
    }
    let $scrollbar = this.$refs['appScrollbar']
    if ($scrollbar) {
      removeResizeListener($scrollbar.$refs['wrap'], this.updateScroll)
      let children = $scrollbar.$refs['resize'].children
      if (children) {
        for (let mChild of children) {
          removeResizeListener(mChild, this.resizeResolver)
        }
      }
    }
  },
  watch: {
    scrollVisible: function (val) {
      if (val) {
        this.$nextTick(() => this.resetLocation())
      }
    }
  }
}
</script>

<style lang="scss">
  .el-scrollbar {
    overflow: hidden!important;
    &.app-scrollbar-y {
      .el-scrollbar__wrap {
        margin-bottom: 0!important;
        overflow-x: hidden;
      }
    }
  }
</style>
